import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "./firebase";

export const BIO_MAX_LENGTH = 140;
export const DISPLAY_NAME_MAX_LENGTH = 40;

export type ProfileEdit = {
  displayName?: string | null;
  bio?: string | null;
  accentColor?: string | null;
};

export function validateProfileEdit(edit: ProfileEdit): {
  ok: true;
} | { ok: false; error: string } {
  if (edit.displayName !== undefined && edit.displayName !== null) {
    if (edit.displayName.length > DISPLAY_NAME_MAX_LENGTH) {
      return {
        ok: false,
        error: `Display name is too long (${DISPLAY_NAME_MAX_LENGTH} max).`,
      };
    }
  }
  if (edit.bio !== undefined && edit.bio !== null) {
    if (edit.bio.length > BIO_MAX_LENGTH) {
      return {
        ok: false,
        error: `Bio is too long (${BIO_MAX_LENGTH} max).`,
      };
    }
  }
  if (edit.accentColor !== undefined && edit.accentColor !== null) {
    if (!/^#[0-9a-fA-F]{6}$/.test(edit.accentColor)) {
      return { ok: false, error: "Accent color must be a hex like #7c5cff." };
    }
  }
  return { ok: true };
}

export async function updateProfile(
  uid: string,
  edit: ProfileEdit
): Promise<void> {
  if (!db) throw new Error("Firestore is not initialized.");
  const v = validateProfileEdit(edit);
  if (!v.ok) throw new Error(v.error);

  // Only forward fields explicitly present in `edit` so we don't accidentally
  // clobber siblings to undefined.
  const payload: Record<string, unknown> = { updatedAt: serverTimestamp() };
  if (edit.displayName !== undefined) {
    payload.displayName = edit.displayName?.trim() || null;
  }
  if (edit.bio !== undefined) {
    payload.bio = edit.bio?.trim() || null;
  }
  if (edit.accentColor !== undefined) {
    payload.accentColor = edit.accentColor || null;
  }

  await updateDoc(doc(db, "users", uid), payload);
}
